import { toBox } from '../CmsAdminPage/BrandingTab/placementModel'

// Wraps raw SVG markup in a data: URI so OverlayEditor's <img src> + fetch()-back parser
// keep working unchanged. The default-overlays GET returns plain text; the editor
// (designed around season-mode S3 URLs) needs something fetchable. useOverlayDataSource
// understands the same prefix on the way back out for save.
const SVG_DATA_URI_PREFIX = 'data:image/svg+xml;base64,'
function svgToDataUri(svg) {
  if (!svg) return null
  // btoa needs a binary string. Encode to UTF-8 bytes first so non-ASCII (Greek text,
  // accents) round-trips correctly instead of triggering 'invalid character' errors.
  const bytes = new TextEncoder().encode(svg)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i])
  return `${SVG_DATA_URI_PREFIX}${btoa(binary)}`
}

/**
 * The editor state a bundled default loads into.
 *
 * Placements are stored point/centre-anchored — the convention the backend's
 * PlacementNormalizer and every bundled default use — while the editor works in top-left
 * boxes, so they are normalized on load exactly as the season parent does. Skipping this
 * drew every field half its own size down and to the right, and made a save (which
 * applies the inverse via fromBox) shift the stored placement by that much for good.
 */
export function buildInitialOverlay(data) {
  if (!data) return null
  return {
    templateSvgUrl: svgToDataUri(data.svg),
    placements: (data.placements ?? []).map(toBox),
    targetMode: data.targetMode ?? null,
  }
}
